module.exports = __webpack_public_path__ + "img/3_5_2.b86bedf2.png";